// sticky bar animation
const stickyBtn = document.querySelector('.set_sticky-btn');
let addFromFlag = 'product_main';

stickyBtn?.addEventListener('click', () => {
  addFromFlag = 'product_quick_add';
  document.querySelector('.set_btn')?.click();
});
const headerWrap = document.querySelector('.header__wrap');
const stickyBar = document.querySelector('.set_sticky-bar');
const isDesktop = window.innerWidth >= 1024;

const mainBtnObserver = new IntersectionObserver(
  ([entry]) => {
    const isHeaderHidden = document.body.classList.contains('hide-header');

    if (entry.isIntersecting) {
      headerObserver.disconnect();

      if (isDesktop) {
        if (isHeaderHidden) {
          stickyBar.classList.remove(
            'tw-translate-y-[100%]',
            'lg:tw-top-0',
            'lg:tw-translate-y-[-100%]'
          );
        } else {
          stickyBar.classList.remove(
            'tw-translate-y-[100%]',
            'lg:tw-top-[113px]',
            'lg:tw-top-0',
            'lg:tw-translate-y-[-100%]'
          );
        }
      } else {
        stickyBar.classList.add('tw-translate-y-[100%]');
      }
    } else {
      if (isDesktop) {
        if (isHeaderHidden) {
          stickyBar.classList.remove(
            'tw-translate-y-[100%]',
            'lg:tw-translate-y-[-100%]'
          );
          stickyBar.classList.add('lg:tw-top-0');
        } else {
          stickyBar.classList.remove(
            'tw-translate-y-[100%]',
            'lg:tw-top-[113px]',
            'lg:tw-translate-y-[-100%]'
          );
          stickyBar.classList.add('lg:tw-top-[48px]');
        }

        headerObserver.observe(headerWrap, {
          attributes: true,
          attributeFilter: ['class']
        });
      } else {
        stickyBar.classList.remove('tw-translate-y-[100%]');
      }
    }
  },
  { threshold: 0.01 }
);

mainBtnObserver.observe(document.querySelector('.set_btn'));

const headerObserver = new MutationObserver(() => {
  if (document.body.classList.contains('hide-header')) return;

  const next = headerWrap.classList.contains('header-up');
  stickyBar.classList.remove(
    'tw-translate-y-[100%]',
    'lg:tw-translate-y-[-100%]'
  );
  if (next) {
    stickyBar.classList.add('lg:tw-top-[48px]');
    stickyBar.classList.remove('lg:tw-top-[113px]');
  } else {
    stickyBar.classList.remove('lg:tw-top-[48px]');
    stickyBar.classList.add('lg:tw-top-[113px]');
  }
});
headerObserver.observe(headerWrap, {
  attributes: true,
  attributeFilter: ['class']
});

document.addEventListener('change', event => {
  const targetInput = event.target.closest(
    '.product_variants .size_slider input'
  );

  if (!targetInput || !(targetInput instanceof HTMLInputElement)) return;

  const label = document.querySelector(`label[for="${targetInput.id}"]`);

  if (targetInput.closest('.color_option_input')) {
    const stickyColor = document.querySelector('.set_sticky-bar__color-option');
    stickyColor.textContent = targetInput.value;

    document.querySelector(
      '.set_sticky-bar .product-color_swatch'
    ).style.backgroundColor =
      label.querySelector('.color_swatch_box').style.backgroundColor;
  } else {
    const stickySize = document.querySelector('.set_sticky-bar__size-option');
    stickySize.textContent = targetInput.value;
  }
});

(() => {
  const priceRoot = document.querySelector('.product-price');
  const stickyMainNodes = document.querySelectorAll('.set_sticky-bar__price');
  const stickyCompareNodes = document.querySelectorAll(
    '.set_sticky-bar__compare-price'
  );

  if (!stickyMainNodes.length && !stickyCompareNodes.length) return;

  const getPrices = () => {
    const moneySpans = priceRoot.querySelectorAll('.price-item, span.money');

    if (!moneySpans.length) return { mainMoney: null, compareMoney: null };

    const moneyArray = Array.from(moneySpans);

    const compareMoney =
      moneyArray.find(el => el.closest('.price-item--regular')) || null;

    let mainMoney =
      moneyArray.find(el => !el.closest('.price-item--regular')) || null;

    if (!mainMoney) {
      mainMoney = moneyArray[0] || null;
    }

    return { mainMoney, compareMoney };
  };

  const syncStickyPrice = () => {
    const { mainMoney, compareMoney } = getPrices();
    if (!mainMoney && !compareMoney) return;

    const isOnePager =
      document.body.dataset.template?.includes('one_pager') || false;

    const resetPriceColor = el => {
      el.classList.remove(
        'tw-text-white',
        'tw-text-[#1e2426]',
        '!tw-text-white',
        '!tw-text-[#DF4243]'
      );
    };

    stickyMainNodes.forEach(node => {
      node.innerHTML = '';

      if (mainMoney) {
        node.appendChild(mainMoney.cloneNode(true));
      }

      const moneySpan = node.querySelector('.money');
      const target = moneySpan || node.querySelector('.price-item');

      resetPriceColor(target);
      if (moneySpan && moneySpan !== node) {
        resetPriceColor(moneySpan);
      }

      if (isDesktop) {
        if (compareMoney) {
          target.classList.add('!tw-text-[#DF4243]');
        } else {
          target.classList.add('tw-text-[#1e2426]');
        }
      } else {
        if (compareMoney) {
          if (isOnePager) {
            target.classList.add('!tw-text-[#DF4243]');
          } else {
            target.classList.add('tw-text-white');
            target.classList.remove('!tw-text-[#DF4243]');
          }
        } else {
          target.classList.add('tw-text-white');
        }
      }
    });

    stickyCompareNodes.forEach(node => {
      node.innerHTML = '';
      if (!compareMoney) return;

      const insideButton = node.closest('.set_sticky-btn');

      if (insideButton) {
        const slash = document.createElement('span');
        slash.className = '!tw-no-underline !tw-text-white tw-mr-1x';
        slash.textContent = '/';
        node.appendChild(slash);
      }

      node.appendChild(compareMoney.cloneNode(true));
    });
  };

  syncStickyPrice();

  let scheduled = false;

  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;

    requestAnimationFrame(() => {
      scheduled = false;
      syncStickyPrice();
    });
  });

  observer.observe(priceRoot, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true
  });
})();
